import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SEOHead from "./components/SEOHead";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ClientsSection from "./components/ClientsSection";
import ModulesSection from "./components/ModulesSection";
import IndustriesSection from "./components/IndustriesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import FeaturesPage from "./pages/FeaturesPage";
import SurveyHubPage from "./pages/SurveyHubPage";
import MeetingRoomPage from "./pages/MeetingRoomPage";
import InvoicingPage from "./pages/InvoicingPage";
import AccessControlPage from "./pages/AccessControlPage";
import CRMPage from "./pages/CRMPage";
import CoworksPage from "./pages/CoworksPage";
import RealEstatePage from "./pages/RealEstatePage";
import MultifamilyPage from "./pages/MultifamilyPage";
import DemoPage from "./pages/DemoPage";
import SupportPage from "./pages/SupportPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead />
      <Header />
      <Hero />
      <ClientsSection />
      <ModulesSection />
      <IndustriesSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/crm" element={<CRMPage />} />
          <Route path="/surveyhub" element={<SurveyHubPage />} />
          <Route path="/meetingroom" element={<MeetingRoomPage />} />
          <Route path="/facturacion" element={<InvoicingPage />} />
          <Route path="/control-acceso" element={<AccessControlPage />} />
          <Route path="/coworks" element={<CoworksPage />} />
          <Route path="/inmobiliarias" element={<RealEstatePage />} />
          <Route path="/multifamily" element={<MultifamilyPage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/soporte" element={<SupportPage />} />
          <Route path="/privacidad" element={<PrivacyPolicyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
